import React from 'react';

export default function DSPageContainer({
  children,
  className = '',
  narrow = false,
  ...props
}) {
  const cls = [
    'ds-page-container',
    narrow && 'ds-page-container--narrow',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={cls} {...props}>
      {children}
    </div>
  );
}
